<div *ngIf="vm.hasCalendarIcon" class="input-group-addon" style="position: absolute; right: 12px; top: 44px">
	<i class="o-icon o-icon--calendar"></i>
</div>
<input type="text" class="c-form__input" [ngClass]="{'c-form__input--sm': vm.isSmall, 'c-form__input--with-button': vm.isClearable}" placeholder="{{vm.placeholder}}" id={{vm.id}} name="{{vm.name}}" [(ngModel)]="vm.inputModel" [required]="vm.isRequired" autocomplete="off">
<button type="button" class="c-form__input-btn" (click)="vm.handleInputReset()" *ngIf="vm.inputModel && vm.isClearable">
	<i class="o-icon o-icon--x" aria-hidden="true"></i>
	<span class="u-sr-only">{{ 'Common.Cancel' | translate }}</span>
</button>
